import { actionTypes } from './types';
import bridgemateAPI from '../apis/bridgemate-apigateway'
import history from '../history';

export const regStart = () => {
    return {
        type: actionTypes.REG_START
    };
}

export const regSuccess = () => {
    return {
        type: actionTypes.REG_SUCCESS
    };
}

export const regFailure = (error) => {
    return {
        type: actionTypes.REG_FAILURE,
        error: error
    };
}

export const reg = (regData) => {
    let list = ( regData.event.registered ) ? regData.event.registered : [];
    list.push({
        player1: regData.player1,
        player2: regData.player2, 
        player3: regData.player3,
        player4: regData.player4
    });

    regData.event.registered = list;
    return async dispatch => { 
        let data = JSON.stringify(regData.event);
        const response = await bridgemateAPI.put('/event',data)
        dispatch({type: actionTypes.CLEAR_EVENT, payload: response.data.Item})
        history.push('/');
    }
}